import { render } from "./DropupLink.vue?vue&type=template&id=6f5ad4f2"
import script from "./DropupLink.vue?vue&type=script&lang=js"
export * from "./DropupLink.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__